import { AfterViewInit, Component, input, OnDestroy, output } from "@angular/core";

import modal from "@uswds/uswds/js/usa-modal";

@Component({
  selector: "download-modal",
  imports: [],
  templateUrl: "./download-modal.component.html",
  styleUrl: "./download-modal.component.scss"
})
export class DownloadModalComponent implements OnDestroy, AfterViewInit {
  isDownloadingResults = input.required<boolean>();
  downloadLink = input.required<string>();
  hasError = input.required<boolean>();

  action = output();

  ngAfterViewInit(): void {
    modal.on();
  }

  ngOnDestroy(): void {
    if (modal) {
      modal.teardown();
    }
  }

  onAction() {
    this.action.emit();
  }
}
